// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng build --env=prod` then `environment.prod.ts` will be used instead.
// The list of which env maps to which file can be found in `.angular-cli.json`.

export const environment = {
  production: false,
  //serviceUrl: 'https://localhost:44357/',
  //appUrl: 'https://localhost:44375/#',
  serviceUrl: 'https://acrn-qa.wolterskluwerlr.com/',
  appUrl: 'https://acrn-qa.wolterskluwerlr.com/#',
  dateFormat: 'mdy',
  autologUrl:'http://35.170.41.112/lbautolog/Default.aspx?auth_token=',
  autologAdmin:'luminad_autologuser@luminad.com',
  AdminTeamId:99,
  autologUserTeamId:140,
  CBAFormId:234
};
